import { useMemo } from 'react';

import type { AddressSearchInput } from '@modules/_shared/utils/addressSearch';

export const useAddressSearchInput = (
  address: AddressSearchInput | null | undefined,
): AddressSearchInput =>
  useMemo(
    () => ({
      route: address?.route,
      street_number: address?.street_number,
      postcode: address?.postcode,
      locality: address?.locality,
    }),
    [
      address?.route,
      address?.street_number,
      address?.postcode,
      address?.locality,
    ],
  );
